var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5948 1.90081C13.3538 2.65986 13.3538 3.89053 12.5948 4.64958L4.56533 12.679C4.46486 12.7795 4.3286 12.8359 4.18652 12.8359H1.19978C0.90391 12.8359 0.664062 12.5961 0.664062 12.3002V9.31348C0.664062 9.1714 0.720504 9.03514 0.82097 8.93467L8.85042 0.905228C9.60947 0.146174 10.8401 0.146174 11.5992 0.905228L12.5948 1.90081ZM11.8372 3.89197C12.1778 3.55134 12.1778 2.99906 11.8372 2.65842L10.8416 1.66284C10.5009 1.32221 9.94867 1.32221 9.60803 1.66284L8.14313 3.12774L10.3723 5.35687L11.8372 3.89197ZM9.61464 6.11449L7.38551 3.88536L1.73549 9.53538V11.7645H3.96462L9.61464 6.11449Z",
    fill: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c8857d88548b4a8c73a8f022c85a6382.svg";
export { ForwardRef as ReactComponent };